// tableStyles.js
export function getTableStyles(styleType) {
  let cardStyle = {};
  let headerStyle = {};
  let rowEvenStyle = {};
  let rowOddStyle = {};
  let totalRowStyle = {};
  let netoStyle = {};

  switch (styleType) {
    case "steampunk":
      cardStyle = {
        padding: "1rem",
        backgroundColor: "#f3ead3", // tono de pergamino
        borderRadius: "12px",
        border: "2px solid #8b5e3c", // borde tipo cobre
        boxShadow: "0 4px 12px rgba(139, 94, 60, 0.4)",
        animation: "neonGlow 2s infinite alternate", // animación neon en el borde
        fontFamily: "'Times New Roman', serif",
        color: "#4a3c31",
      };
      headerStyle = {
        backgroundColor: "#8b5e3c",
        "& th": {
          fontWeight: "bold",
          color: "#f3ead3",
          textShadow: "0 0 8px #ffcc00",
          animation: "neonGlow 2s infinite alternate",
        },
      };
      rowEvenStyle = {
        backgroundColor: "#fff8ee",
        "& td": {
          fontSize: "0.9rem",
          color: "#4a3c31",
          borderBottom: "none",
          animation: "neonGlow 2s infinite alternate",
        },
      };
      rowOddStyle = {
        backgroundColor: "#f7f1e1",
        "& td": {
          fontSize: "0.9rem",
          color: "#4a3c31",
          borderBottom: "none",
          animation: "neonGlow 2s infinite alternate",
        },
      };
      totalRowStyle = {
        backgroundColor: "#e8dfc6",
        "& td": {
          fontWeight: "bold",
          fontSize: "0.95rem",
          color: "#8b5e3c",
          borderBottom: "none",
          textShadow: "0 0 8px #ffcc00",
          animation: "neonGlow 2s infinite alternate",
        },
      };
      netoStyle = {
        fontWeight: "bold",
        fontSize: "1rem",
        color: "#8b5e3c",
        textShadow: "0 0 8px #ffcc00",
        animation: "neonGlow 2s infinite alternate",
      };
      break;

    case "bubblegum":
      cardStyle = {
        padding: "1rem",
        background: "linear-gradient(135deg, #2a2a2a, #1a1a1a)",
        borderRadius: "16px",
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.9)",
        color: "#f0f0f0",
      };
      headerStyle = {
        backgroundColor: "#1a1a1a",
        borderBottom: "2px solid #ff007f",
        "& th": {
          fontWeight: "bold",
          color: "#ff80bf",
          textShadow: "0 0 5px #ff00ee",
        },
      };
      rowEvenStyle = {
        backgroundColor: "#2a2a2a",
        color: "#f0f0f0",
        "&:hover": { backgroundColor: "#3a3a3a" },
      };
      rowOddStyle = {
        backgroundColor: "#242424",
        color: "#f0f0f0",
        "&:hover": { backgroundColor: "#3a3a3a" },
      };
      totalRowStyle = {
        backgroundColor: "#1c1c1c",
        borderBottom: "2px solid #ff007f",
        "& td": {
          fontWeight: "bold",
          color: "#ff80bf",
          textShadow: "0 0 5px #ff00ee",
        },
      };
      netoStyle = {
        fontWeight: "bold",
        fontSize: "1rem",
        color: "#ff80bf",
        textShadow: "0 0 5px #ff00ee",
      };
      break;
    case "minimalist":
      cardStyle = {
        padding: "1rem",
        backgroundColor: "#f8f9fa",
        borderRadius: "12px",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
        color: "#2e2e2e",
        fontFamily: "'Roboto', sans-serif",
      };
      headerStyle = {
        backgroundColor: "#e0e0e0",
        "& th": {
          fontWeight: "bold",
          color: "#1a1a1a",
          borderBottom: "none",
        },
      };
      rowEvenStyle = {
        backgroundColor: "#f5f5f5",
        "& td": { fontSize: "0.9rem", color: "#263238", borderBottom: "none" },
      };
      rowOddStyle = {
        backgroundColor: "#ffffff",
        "& td": { fontSize: "0.9rem", color: "#263238", borderBottom: "none" },
      };
      totalRowStyle = {
        backgroundColor: "#e3f2fd",
        "& td": {
          fontWeight: "bold",
          fontSize: "0.95rem",
          color: "#0d47a1",
          borderBottom: "none",
        },
      };
      netoStyle = {
        fontWeight: "bold",
        fontSize: "1rem",
        color: "#0d47a1",
      };
      break;
    case "corporate":
    default:
      cardStyle = {
        padding: "1rem",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
        boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
        fontFamily: "'Roboto', sans-serif",
      };
      headerStyle = {
        backgroundColor: "#0d47a1",
        "& th": {
          color: "#ffffff",
          fontWeight: "bold",
          fontSize: "0.95rem",
        },
      };
      rowEvenStyle = {
        backgroundColor: "#f5f5f5",
        "& td": { fontSize: "0.9rem", color: "#263238", borderBottom: "none" },
      };
      rowOddStyle = {
        backgroundColor: "#ffffff",
        "& td": { fontSize: "0.9rem", color: "#263238", borderBottom: "none" },
      };
      totalRowStyle = {
        backgroundColor: "#e3f2fd",
        "& td": {
          fontWeight: "bold",
          fontSize: "0.95rem",
          color: "#0d47a1",
          borderBottom: "none",
        },
      };
      netoStyle = {
        fontWeight: "bold",
        fontSize: "1rem",
        color: "#0d47a1",
      };
      break;
  }

  return {
    cardStyle,
    headerStyle,
    rowEvenStyle,
    rowOddStyle,
    totalRowStyle,
    netoStyle,
  };
}
